import * as Yup from "yup";
import { COMPANY_BASE_PROPERTIES } from "../../../../api/constants";
import {campaignDateValidation} from "./sharedValidationConfig";

export const storygizeConfig = {
    ...COMPANY_BASE_PROPERTIES,
    /**
     * User Readable name of company the user is onBoarding with
     */
    companyText: "Onboarding With Storygize",

    /**
     * lowercase no spaces or underscores name of company
     * This will be passed to the activate model and
     * used when saving to create the correct submission url
     */
    company: "storygize",

    /**
     * HTML that explains how to use the form
     */
    instructions:
     "<strong>Platform and Billing Notice</strong><br><br>" +
     "Segments will be billed at the CPM or Percent of Media rate listed at the bottom of this page, based on the number of deployed records per month.",
    /**
     * data used to create a company activation block
     */
    companyBlockOptions: {
        val: "storygize",
        text: "Storygize",
        img: "storygize-logo.png",
    },

    /**
     * anchor tag used to login to a specific platform
     */
    loginLink:
        '<a href="https://app.storygize.com" target="_blank">Log in to Storygize</a>',

    layout: [
        {
            fieldType: "checkboxGroup",
            labelText: "Devices to Activate",
            fieldName: "device_type",
            required: false,
            checkboxes: [
                {
                    labelText: "Storygize ID",
                    fieldName: "CLIENT_ID",
                    value: "CLIENT_ID",
                    checked: true,
                    disabled: false,
                },
                // {
                //     labelText: "Hashed Emails",
                //     fieldName: "hashed_emails",
                //     value: "hashed_emails_sha256",
                //     checked: true,
                //     disabled: false,
                // },
            ],
        },
        {
            fieldType: "radioGroup",
            labelText: "Mobile Devices",
            fieldName: "mobile_devices",
            required: true,
            radioButtons: [
                {
                    labelText: "Top Devices",
                    fieldName: "top_devices",
                    value: "top_ios_android",
                    checked: true,
                },
                {
                    labelText: "All Devices",
                    fieldName: "all_devices",
                    value: "ios_android",
                    checked: false,
                },
                {
                    labelText: "No Devices",
                    fieldName: "no_devices",
                    value: "no_devices",
                    checked: false,
                },
            ],
        },
        {
            fieldType: "dateRange",
            fieldName: "campaign_range",
            labelText: "Campaign Date Range",
            required: "dateRangeRequired",
        },
        {
            fieldType: 'savableFieldsWrapper',
            layout: [
                {
                    fieldType: 'searchSelect',
                    fieldName: 'seat_id',
                    labelText: 'Seat Name',
                    url: '/v2/secure/attributor/activate-credentials/storygize/seat_id',
                    placeholder: "Select a Seat Name or add a new one",
                    namePropName: 'value',
                    textPropName: 'value',
                    valuePropName: 'id',
                    required: true,
                    validation: [{
                        required: function (value, attr, computed) {
                            if (!value) {
                                return 'Seat name is required'
                            }
                        }
                    }]
                }, {
                    fieldType: 'checkbox',
                    fieldName: 'save_credentials',
                    labelText: 'Save seat name</span> for future use',
                    checked: false,
                },
            ]
        },
        {
            fieldType: "radioGroup",
            labelText: "Planned Usage of this Segment:",
            fieldName: "audience_usage",
            required: true,
            radioButtons: [
                {
                    labelText: "Targeting",
                    fieldName: "use_type_inclusion",
                    value: "I",
                    checked: false,
                },
                {
                    labelText: "Suppression",
                    fieldName: "use_type_exclusion",
                    value: "X",
                    checked: false,
                },
            ],
        },
        {
            fieldType: "selectPickerTag",
            fieldName: "creativeTagIdDropDown",
            labelText: "Creative Tag ID",
            url: "/v2/secure/attributor/creative-tags",
            placeholder: "Select a New or existing Tag for your creative",
            namePropName: "creativeTagId",
            textPropName: "creativeTagId",
            valuePropName: "creativeTagId",
            required: true,
        },
        {
            fieldType: "creativeTagId",
            fieldName: "creativeTagId",
            labelText: "Creative Tag ID",
            required: true,
        },
        {
            fieldType: "creativeTag",
            fieldName: "creativeTag",
            labelText: "Creative Tag",
            required: true,
        },
        {
            fieldType: "pricing",
        },
    ],

    /**
     * an array of property names that can be saved and repeatedly used to "Activate/OnBoard" with a specific company
     */
    savableDataNames: ["seat_id"],

    formik: {
        initialValues: {
            // device_type: ["CLIENT_ID", "hashed_emails_sha256"],
            device_type: ["CLIENT_ID"],
            mobile_devices: "top_ios_android",
            campaign_range_start: "",
            campaign_range_end: "",
            audience_usage: "",
            creativeTagIdDropDown: "",
            creativeTagId:"",
            seat_id:"",
            // demand_partners: "",
            // buyer_id: ""
        },
        // We used Yup here for data validation and condition.
        validationSchema: Yup.object().shape({
            mobile_devices: Yup.string().required("Mobile Devices is required"),
            seat_id: Yup.string().required("Seat Name is required").max(515, "Seat Name should not exceed 515 characters"),
            // demand_partners: Yup.string().required("Demand Partner is required").max(80, "Seat Name should not exceed 515 characters"),
            // buyer_id: Yup.string().required("Demand Partner Buyer ID is required").max(128, "Demand Partner Buyer ID should not exceed 128 characters"),
            ...campaignDateValidation,
            audience_usage: Yup.string().required("Planned Usage is required"),
            creativeTagIdDropDown: Yup.string().required("Creative Tag ID is required"),
            creativeTagId: Yup.string().required("Creative Tag ID is required")
        }),
        onSubmit: (values) => {},
    },
};
